import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";


const FAQAccordion = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="pt-16 max-w-7xl mx-auto font-['EB_Garamond','Nunito','sans-serif']">
      <div>
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-[rgba(234,126,93,0.5)]">
            <button
              className="w-full flex justify-between items-center p-4 text-left font-bold text-lg font-semibold transition hover:text-[rgb(234,126,93)]"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              {activeIndex === index ? (
                <FaMinus className="text-[rgb(234,126,93)]" />
              ) : (
                <FaPlus className="text-[rgb(234,126,93)]" />
              )}
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700 bg-[rgba(234,126,93,0.1)] text-lg border-t border-[rgb(234,126,93)] whitespace-pre-line">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQAccordion;